import React from 'react';
/* eslint no-unused-vars: 0 */
import css from 'locations_field.scss';

function LocationsField(props) {
    if (props.location !== null || (props.locations.length === 0 && props.regions.length === 0)) {
        return <span className="location-label">
            <span className="borough-label">{props.location}</span>
        </span>;
    }

    if (props.locations.length === 0) {
        const city = props.regions.find(city => city.checked === true);
        const areas = city.children.filter(area => area.checked === true);

        return (
            <span className="location-label">
                <span className="city-label">{city.name}</span>
                {areas.map(area => {
                    const children = area.children.filter(child => child.checked === true).map(child => child.name);
                    return <span className="borough" key={`borough${area.id}`}>
                        <span className="borough-label">{area.name}</span>
                        {children.length > 0 && children.length !== area.children.length && <span className="neighborhood-labels">
                            (Selected Neighborhoods)
                        </span>}
                    </span>;
                })}
            </span>
        );
    }

    return (
        <span className="location-label">
            <span className="city-label">{props.locations[0]}</span>
            {typeof props.locations[1] === 'object' && props.locations[1].map(child => {
                if (typeof child === 'object') {
                    return <span className="borough" key={`borough${child[0]}`}>
                        <span className="borough-label">{child[0]}</span>
                    </span>;
                }

                return <span className="borough" key={`boroughCollapsed${child}`}><span className="borough-label">{child}</span></span>;
            })}
        </span>
    );
}

LocationsField.propTypes = {
    regions: React.PropTypes.array,
    locations: React.PropTypes.array,
    location: React.PropTypes.string,
};

LocationsField.defaultProps = {
    regions: [],
    locations: [],
    location: null,
};

export default LocationsField;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/events/LocationsField.jsx